import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { CoreStatus } from '@ingenico/react-ui/core-status';
import classNames from 'classnames';
import { isEqual } from 'lodash-es';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreCardWithLabel } from '../core-card-with-label/CoreCardWithLabel.ctrl';
import { LabelAndContentColumn } from '../label-and-content-column/LabelAndContentColumn.ctrl';
import type { LogicalDeviceSIMInformationProps } from './logicalDeviceSIMInformation.model';
import styles from './logicalDeviceSIMInformation.module.scss';

export function LogicalDeviceSIMInformation({
  networkOperator,
  networkStatus,
  IMSI,
  IMEI,
  operatorSIM,
}: LogicalDeviceSIMInformationProps): ReactNode {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.LOGICAL_DEVICE]);
  return (
    <CoreCardWithLabel title={t('logicalDevice.simInformation.title')}>
      <div className={classNames(styles.networkContainer)}>
        {isEqual(networkStatus, 'ACTIVE') ? (
          <CoreStatus
            label={t('logicalDevice.simInformation.label.active')}
            status="success"
            customClassName={classNames(styles.statusText)}
          />
        ) : (
          <CoreStatus
            label={t('logicalDevice.simInformation.label.inactive')}
            status="failed"
            customClassName={classNames(styles.statusText)}
          />
        )}

        <div className={classNames(styles.container)}>
          <div className={classNames(styles.leftContainer)}>
            <LabelAndContentColumn
              label={t('logicalDevice.simInformation.networkOperator')}
              content={networkOperator}
            />
            <LabelAndContentColumn label={t('logicalDevice.simInformation.IMSI')} content={IMSI} />
          </div>
          <div className={classNames(styles.rightContainer)}>
            <LabelAndContentColumn label={t('logicalDevice.simInformation.simOperator')} content={operatorSIM} />
            <LabelAndContentColumn label={t('logicalDevice.simInformation.IMEI')} content={IMEI} />
          </div>
        </div>
      </div>
    </CoreCardWithLabel>
  );
}
